import React from 'react';
import PropTypes from 'prop-types';

const RelationDocumentDetail = ({ document }) => {
  if (!document.recognitionMeta) return null;

  const data =
    typeof document.recognitionMeta === 'string'
      ? JSON.parse(document.recognitionMeta)
      : document.recognitionMeta;
  const { relationFirstName, relationName, relationAddress } = data;

  return (
    <div className="margin10B">
      <div>{`${relationFirstName === null ? '' : relationFirstName} ${relationName}`.trim()}</div>
      <div>{relationAddress}</div>
    </div>
  );
};

RelationDocumentDetail.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default RelationDocumentDetail;
